var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5899 13.0904C19.4299 13.0904 19.2699 13.0404 19.1299 12.9304C15.0999 9.82039 9.88993 9.82039 5.85993 12.9304C5.52993 13.1804 5.05993 13.1204 4.80993 12.8004C4.55993 12.4704 4.61993 12.0004 4.93993 11.7504C9.52993 8.20039 15.4599 8.20039 20.0399 11.7504C20.3699 12.0004 20.4299 12.4704 20.1699 12.8004C20.0399 12.9904 19.8199 13.0904 19.5899 13.0904Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 9.61039C22.34 9.61039 22.18 9.56039 22.04 9.45039C16.24 4.97039 8.75001 4.97039 2.96001 9.45039C2.63001 9.70039 2.16001 9.64039 1.91001 9.32039C1.65001 9.00039 1.71001 8.52039 2.04001 8.27039C8.39001 3.36039 16.6 3.36039 22.96 8.27039C23.29 8.52039 23.35 8.99039 23.09 9.32039C22.95 9.51039 22.72 9.61039 22.5 9.61039Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7096 16.7403C17.5496 16.7403 17.3896 16.6903 17.2496 16.5803C14.3696 14.3503 10.6396 14.3503 7.74958 16.5803C7.41958 16.8303 6.94958 16.7703 6.69958 16.4503C6.44958 16.1203 6.50958 15.6503 6.82958 15.4003C10.2696 12.7403 14.7196 12.7403 18.1596 15.4003C18.4896 15.6503 18.5496 16.1203 18.2896 16.4503C18.1496 16.6403 17.9296 16.7403 17.7096 16.7403Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1002 20.4005C14.9402 20.4005 14.7802 20.3505 14.6402 20.2405C13.3402 19.2305 11.6502 19.2305 10.3502 20.2405C10.0202 20.4905 9.55017 20.4305 9.30017 20.1105C9.05017 19.7805 9.11017 19.3105 9.43017 19.0605C11.2902 17.6205 13.6902 17.6205 15.5502 19.0605C15.8802 19.3105 15.9402 19.7805 15.6802 20.1105C15.5502 20.2905 15.3302 20.4005 15.1002 20.4005Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiInactive);
export default __webpack_public_path__ + "static/media/wifi-inactive.4b7a7a3a5cd86d5a7ddbabe1bf331546.svg";
export { ForwardRef as ReactComponent };